import { proxy } from 'valtio';

import { Shapes, type ShapeToolShape } from '@canvas/model/shapes';

export const defaultShape = Shapes.Ellipse;

export const currentSelectedShape: Record<'selectedShape', ShapeToolShape> = proxy({
  selectedShape: defaultShape,
});
